import React, { ReactElement } from 'react';
import { Component } from "puzzle"
import { REJECTED_FILES_DATA } from "../Types";

type PROPS = {
  rejectedFilesData: REJECTED_FILES_DATA
};

export class RejectedFilesDialog extends Component<{}, PROPS> {

  /**x
   * Renders sections for duplicated, fileNameTooLong, invalidFileName
   */
  renderSections = (): null | ReactElement<HTMLDivElement>[] => {
    let sections: ReactElement<HTMLDivElement>[] = [];
    ['duplicated', 'fileNameTooLong', 'invalidFileName'].reduce((container: ReactElement<HTMLDivElement>[], sectionName: string) => {
      const rejected = this.props.rejectedFilesData[sectionName];
      if (rejected && rejected.length) {
        container.push(
          <div key={`section_${sectionName}`} className={'tp-warning-dialog-list'}>
            <span className={'tp-text-semibold'}>{this.translate(sectionName)}</span>
            <ul>
              {rejected.map(this.renderRejectedFiles)}
            </ul>
          </div>
        )
      }
      return container;
    }, sections);

    return sections.length ? sections : null;
  };

  /**
   * Render for individual file
   * @param fileName
   */
  renderRejectedFiles = (fileName: string): React.ReactElement<HTMLLIElement> => <li key={fileName}>{fileName}</li>;

  /**
   * @inheritDoc
   */
  renderBody = (): React.ReactElement<HTMLDivElement> => {
    return (
      <>
        <div className={'tp-warning-text tp-font-size-md tp-text-semibold'}>
          {this.translate('subTitle')}
        </div>
        {this.renderSections()}
        <div className={'tp-additional-text tp-text-semibold'}>
          {this.translate('tryAgain')}
        </div>
      </>
    )
  }
}
